import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled from "styled-components";
import { I18n } from "react-redux-i18n";
import Utilities from "../../Helpers/Utilities";
import { getXsrfToken } from "../../Store/Security/Actions";
import { updateCartItem, removeFromCart } from "../../Store/Cart/Actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";

// region Styles
const Item = styled.div`
    margin-top: 10px;
`;

const BoxedColumn = styled.div`
    ${Item} & {
        margin-bottom: 0;
        padding: 0 15px;
    }
`;

const ItemImage = styled.img`    
    // Extra Small devices (portrait phones, less than 576px)
    @media (max-width: 575.98px) {
        max-height: 150px;
        display: block;
        margin: 0 auto;
    }
    
    // Small devices (landscape phones, 576px and up)
    @media (min-width: 576px) {
        max-height: 100%;
    }
`;

const ItemName = styled.div`
    margin-bottom: 5px;
`;

const ItemInfo = styled.div`
    // Small devices (landscape phones, less than 768px)
    @media (max-width: 767.98px) {
        margin-right: 0;
        margin-left: 0;
        margin-top: 10px;
    }
`;

const PriceContainer = styled.div`
    &.boxed {
        margin-bottom: 0;
        padding: 0 15px;
    }

    // Small devices (landscape phones, less than 768px)
    @media (max-width: 767.98px) {
        text-align: left;
    }

    // Medium devices (tablets, 768px and up)
    @media (min-width: 768px) {
        text-align: right;
    }
`;

const QtyInputContainer = styled.div`
    padding-right: 0;
    
    // Medium devices (tablets, 768px and up)
    @media (min-width: 768px) and (max-width: 991.98px) {
        margin-top: 5px;
    }
`;

const RemoveButtonContainer = styled.div`
    padding-left: 0;
    
    // Medium devices (tablets, 768px and up)
    @media (min-width: 768px) and (max-width: 991.98px) {
        margin-top: 5px;
    }
`;

const RemoveButton = styled(FontAwesomeIcon)`
    margin-left: 10px;
    margin-bottom: 1px;
    font-size: 12px;
    cursor: pointer;
`;
// endregion

class CartItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            quantity: props.item.quantity
        };
    }

    onQuantityChange(e) {
        const quantity = e.target.value;

        this.setState({ quantity });
    }

    onQuantityBlur(e) {
        const { item, updateCartItem, getXsrfToken } = this.props;
        const quantity = parseInt(e.target.value || "0");

        getXsrfToken(({ token }) => {
            updateCartItem({ itemId: item.id, newQuantity: quantity, __RequestVerificationToken: token });
        });
    }

    onClickRemove(itemId) {
        const { removeFromCart, getXsrfToken } = this.props;

        getXsrfToken(({ token }) => {
            removeFromCart({ itemId, __RequestVerificationToken: token });
        });
    }

    render() {
        const { item, showDescription } = this.props;
        const { quantity } = this.state;

        return (
            <Item className="row cart-item-container">
                <BoxedColumn className="col-sm-12 col-md-10 col-lg-8 boxed">
                    <div className="row">
                        <BoxedColumn className="col-3 col-sm-2 boxed">
                            <ItemImage alt={item.picture.alternateText || "Image"} className="border--round" src={item.picture.fullSizeImageUrl}/>
                        </BoxedColumn>
                        <BoxedColumn className="col-9 col-sm-10 boxed">
                            <ItemName>
                                {item.productName} {item.attributes && item.attributes.length > 0 ? `(${item.attributes.join(", ")})` : ""}
                            </ItemName>
                            {showDescription && item.productDescription && !item.categoryName.toLowerCase().includes(I18n.t("accessories.accessories").toLowerCase()) &&
                            <p className="type--fade">
                                {item.productDescription}
                            </p>}
                        </BoxedColumn>
                    </div>
                </BoxedColumn>
                <BoxedColumn className="col-sm-12 col-md-2 col-lg-4 boxed">
                    <ItemInfo className="row">
                        <PriceContainer className="col-4 col-md-12 col-lg-7 col-xl-8 boxed">
                            {item.unitPrice}
                        </PriceContainer>
                        <BoxedColumn className="col-8 col-md-12 col-lg-5 col-xl-4 text-right boxed">
                            <div className="row">
                                <QtyInputContainer className={"col-4 col-sm-6 col-md-8 col-lg-7 col-xl-8"}>
                                    <input value={quantity} type="number" min={0} disabled={item.isRequiredProduct} onChange={this.onQuantityChange.bind(this)} onBlur={this.onQuantityBlur.bind(this)} />
                                </QtyInputContainer>

                                {/* only non required items can be removed individually. */}
                                {!item.isRequiredProduct && item.kitIds.length === 0 &&
                                <RemoveButtonContainer className="col-4 col-sm-2 col-md-4 col-lg-5 col-xl-4">
                                    <RemoveButton icon={faTrashAlt} onClick={() => {
                                        this.onClickRemove(item.id)
                                    }} />
                                </RemoveButtonContainer>
                                }
                            </div>
                        </BoxedColumn>
                    </ItemInfo>
                </BoxedColumn>
            </Item>
        );
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getXsrfToken: getXsrfToken,
        updateCartItem: updateCartItem,
        removeFromCart: removeFromCart
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CartItem);